import { Box, styled, Typography } from '@mui/material';

export const DataContainerStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'activeStep',
})(({ theme, activeStep }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingBottom: activeStep === 2 && '20px',
  [activeStep === 2 && theme.breakpoints.up('lg')]: {
    paddingRight: '6px',
    overflowY: 'auto',

    '@-moz-document url-prefix()': {
      scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
      scrollbarWidth: 'thin',
    },
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
      borderRadius: '5px',
    },
  },
}));

export const OrderSectionStyled = styled(Box)(({ theme, index }) => ({
  marginTop: index !== 0 && '24px',
  width: '100%',
  maxWidth: '408px',
  [theme.breakpoints.down('lg')]: {
    maxWidth: '313px',
  },
}));

export const OrderTitleContainerStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.colors.pillBackgroundLight,
  padding: '8px 9px 8px 7px',
  borderRadius: '5px',
}));

export const TitleStyled = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  color: theme.palette.colors.mainFocused,
}));

export const OrderContentContainerStyled = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
}));

export const SectionElementStyled = styled(Box)(({ theme }) => ({
  padding: '10px 23px 0 0',
  minWidth: '50%',
  [theme.breakpoints.down('lg')]: {
    minWidth: '100%',
  },
  fontSize: '12px',
  fontWeight: 500,
  textTransform: 'uppercase',
  color: theme.palette.colors.label,
}));

export const ValueStyled = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  marginLeft: '8px',
}));
